"use client";

import type { LDClient, LDFlagSet } from "launchdarkly-react-client-sdk";
import { createContext } from "react";

export type ABContext = {
  flags: LDFlagSet;
  isLoading: boolean;
  ldClient: LDClient;
};

export const abContext = createContext<ABContext>({
  flags: {},
  isLoading: true,
  ldClient: null,
});
